import Hero from 'components/home/Hero';
import BrandStatement from 'components/home/BrandStatement';
import ProductHighlights from 'components/home/ProductHighlights';
import OrderSection from 'components/order/OrderSection';
import WhySingaraaPreview from 'components/home/WhySingaraaPreview';
import HeritageSection from 'components/home/HeritageSection';
import PeanutBenefits from 'components/home/PeanutBenefits';
import PageMeta from 'components/layout/PageMeta';

export const metadata = {
  title: 'Singaraa | Premium Dry Roasted Peanuts & Wholesale Snacks',
  description: 'Singaraa brings premium dry roasted peanuts with a naturally crunchy taste, rooted in Indian snacking culture. Order directly or inquire for wholesale.',
};

export default function HomePage() {
  return (
    <main className="min-h-screen bg-singaraa-ivory">
      <PageMeta title={metadata.title} description={metadata.description} />
      <Hero />
      <BrandStatement />
      <ProductHighlights />
      <OrderSection 
        id="order-now"
        eyebrow="FRESH ROASTED SNACKS"
        title="Order Your Pack of Singaraa"
        subtitle="Crunchy, protein-rich dry roasted peanuts delivered fresh to your doorstep"
      />
      <PeanutBenefits />
      <WhySingaraaPreview />
      <HeritageSection />
    </main>
  );
}
